import { Spin } from 'antd';

/**
 * UX-050: antd v5's `<Spin tip="...">` only renders the tip when used in
 * wrapper mode (with children). Standalone `<Spin tip="Authenticating...">`
 * shows just the dot, hiding the message. Render the tip text manually below
 * the spinner.
 */
const LoadingSpinner: React.FC<{ tip?: string }> = ({ tip = 'Loading...' }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
    role="status"
    aria-live="polite"
    aria-label={tip}
  >
    <Spin size="large" />
    {tip && (
      <div style={{ color: '#8c8c8c', fontSize: 13 }}>{tip}</div>
    )}
  </div>
);

export default LoadingSpinner;
